'use es6';

import { TrialsApi } from 'self-service-api/core/api/trialApi';
import availableTrialsAdapter from 'self-service-api/adapters/availableTrialsAdapter';
export var getAvailableTrials = function getAvailableTrials() {
  return TrialsApi.getAvailableTrials().then(function (availableTrials) {
    return availableTrialsAdapter(availableTrials);
  });
};